import axios from 'axios'

export function regeo(longitude: any, latitude: any) {
  return axios.get(`https://restapi.amap.com/v3/geocode/regeo?location=${longitude},${latitude}&key=945c084635e272e8067d2082c3b6554c&radius=1000&extensions=all`)
}